class RelatedArticle extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }
  connectedCallback() {
    this.initSwiper();
  }
  initSwiper() {
    const container = this.querySelector(".related-article__item-container");
    if (!container) return;
    const items = container.querySelectorAll(".related-article__item");
    const parentFilter = this.closest('.related-article__tags');
    const tagFilter = parentFilter.getAttribute('data-article-tag');
    const scrollbar = this.querySelector(`#related-article-scrollbar-${tagFilter}`);;
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
    if (items.length > 1) {
      this.swiperInstance = new Swiper(container, {
        spaceBetween: 8,
        slidesPerView: "auto",
        scrollbar: {
          el: scrollbar,
          draggable: true,
          dragSize: 237,
        },
      });
    }
  }
}
customElements.define("related-article", RelatedArticle);
class RelatedArticleElm extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.tabContent();
  }
  tabContent() {
    const tabTitles = this.querySelectorAll(".rocket-related-article__tags");
    const tabContainers = this.querySelectorAll(".related-article__tags");
    tabTitles.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabTitles.forEach((t) => t.classList.remove("active"));
        tab.classList.add("active");
        const tagValue = tab.getAttribute("data-article-tag");
        tabContainers.forEach((container) => {
          if (container.getAttribute("data-article-tag") === tagValue) {
            container.classList.add("active");
            setTimeout(() => {
              container.querySelectorAll("related-article").forEach((element) => {
                if (typeof element.initSwiper === "function") {
                  element.initSwiper();
                }
              });
            }, 100);
          } else {
            container.classList.remove("active");
          }
        });
      });
    });
  }
}
customElements.define("related-article-elm", RelatedArticleElm);